import { Controller, useFormContext } from 'react-hook-form'

import { countries } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { updateStateField } from '../../../../../../../../helpers'
import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const Country = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control, setValue, getValues, clearErrors } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.addressesInfo.${index2 as 0}.country`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="15. Country"
          input={(props) => (
            <Select
              {...props}
              searchable
              data={countries}
              emptyOption={{ label: 'Not selected', value: '' }}
              disabled={isAllInfoUnavailable}
              data-qa="15. Country"
              options-data-qa="15. Country option"
              onChange={(value) => {
                updateStateField(
                  `subjectsInfo.${index1 as 0}.addressesInfo.${index2 as 0}.state`,
                  value,
                  setValue,
                  getValues,
                  clearErrors
                )
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
